import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import ModalConfirmacion from "../../../general/componentes/ModalConfirmacion";
import { Parametro, SolicitudAdminParametro } from "../modelo/AdminParametro";
import { ProcesoAdmin } from "../../config_general/modelo/ProcesoAdmin";
import { gestionarParametro } from "../modulos/adminParametroActions";
import { TipoDatos } from "../../config_general/modelo/TipoDatos";
import { ModalGestionarParametro } from "./ModalGestionarParametro";
import AccionAdministracion from "../../config_general/componentes/AccionAdministracion";
import { IconoAccion } from "../../config_general/modelo/IconoAccion";

class ModalAdminParametros extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            showModalCrear: false,
            showModalActualizar: false,
            showModalBorrar: false
        };

    }

    render() {

        return (
            <div>
                <button type="button" className="btns btns-glyphicon" onClick={this.mostrarModalCrear}
                    disabled={this.state.showModalCrear}>
                    <AccionAdministracion texto="Crear" icono={IconoAccion.CREAR} />
                </button>
                <button type="button" className="btns btns-glyphicon" onClick={this.mostrarModalActualizar}
                    disabled={this.state.showModalActualizar}>
                    <AccionAdministracion texto="Editar" icono={IconoAccion.EDITAR} />
                </button>
                <button type="button" className="btns btns-glyphicon" onClick={this.mostrarModalBorrar}
                    disabled={this.state.showModalBorrar}>
                    <AccionAdministracion texto="Borrar" icono={IconoAccion.BORRAR} />
                </button>
                {this.crearParametro()}
                {this.actualizarParametro()}
                {this.borrarParametro()}
            </div >
        );
    }

    crearParametro = () => {
        return (
            <ModalGestionarParametro
                titulo={"Crear Parámetro"}
                esCrear
                codigo={this.props.codigo}
                valor1={this.props.valor1}
                valor2={this.props.valor2}
                valor3={this.props.valor3}
                valor4={this.props.valor4}
                dniIngresa={this.props.dniIngresa}
                fechaIngresa={this.props.fechaIngresa}
                show={this.state.showModalCrear}
                onAceptar={this.crear}
                onCancelar={this.cerrarModalCrear} />

        );
    }

    actualizarParametro = () => {
        return (
            <ModalGestionarParametro
                titulo={"Actualizar Parámetro"}
                esCrear={false}
                codigo={this.props.codigo}
                valor1={this.props.valor1}
                valor2={this.props.valor2}
                valor3={this.props.valor3}
                valor4={this.props.valor4}
                dniIngresa={this.props.dniIngresa}
                fechaIngresa={this.props.fechaIngresa}
                show={this.state.showModalActualizar}
                onAceptar={this.actualizar}
                onCancelar={this.cerrarModalActualizar} />

        );
    }

    borrarParametro = () => {
        return (
            <ModalConfirmacion titulo={"Confirmar"}
                show={this.state.showModalBorrar}
                onAceptar={this.borrar}
                onCancelar={this.cerrarModalBorrar}>
                ¿Confirma que desea borrar el parametro {this.props.codigo}?
            </ModalConfirmacion>
        );
    }

    borrar = () => {
        const parametro: Parametro = {
            tipo: TipoDatos.PARAMETRO,
            codigo: this.props.codigo,
            dniIngresa: this.props.dniIngresa,
            fechaIngresa: this.props.fechaIngresa
        };

        const solicitud: SolicitudAdminParametro = {
            dniModifica: this.props.dniUsuarioGestionLogin,
            datos: parametro,
            tipoProceso: ProcesoAdmin[2].codigo
        };

        this.cerrarModalBorrar();
        this.props.dispatch(gestionarParametro(solicitud));
    };

    actualizar = (parametro: Parametro) => {
        const solicitud: SolicitudAdminParametro = {
            dniModifica: this.props.dniUsuarioGestionLogin,
            datos: parametro,
            tipoProceso: ProcesoAdmin[1].codigo
        };

        this.cerrarModalActualizar();
        this.props.dispatch(gestionarParametro(solicitud));
    };

    crear = (parametro: Parametro) => {
        const solicitud: SolicitudAdminParametro = {
            dniModifica: this.props.dniUsuarioGestionLogin,
            datos: parametro,
            tipoProceso: ProcesoAdmin[0].codigo
        };

        this.cerrarModalCrear();
        this.props.dispatch(gestionarParametro(solicitud));
    };

    cerrarModalBorrar = () => {
        this.setState({ showModalBorrar: false });
    };

    mostrarModalBorrar = () => {
        this.setState({ showModalBorrar: true });
    };

    cerrarModalActualizar = () => {
        this.setState({ showModalActualizar: false });
    };

    mostrarModalActualizar = () => {
        this.setState({ showModalActualizar: true });
    };

    cerrarModalCrear = () => {
        this.setState({ showModalCrear: false });
    };

    mostrarModalCrear = () => {
        this.setState({ showModalCrear: true });
    };
}

export default connect((store: any, props: any) => {
    return {
        ...props,
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store)
    };
})(ModalAdminParametros);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_parametros/componentes/ModalAdminParametros.tsx